<div class="footer">
  <div class="footer-links">
    <a [href]="privacyPolicyLink()" target="_blank">Privacy Policy</a>
    <a [routerLink]="['/tis-support']">Contact</a>
  </div>
  <div>{{ copyright() }}</div>
</div>